import { createActions, createReducer } from 'reduxsauce'

import ConsultaQuadroInativosADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaQuadroInativosADMRHInicio: [],
    buscaConsultaQuadroInativosADMRHErro: ['erro'],
    buscaConsultaQuadroInativosADMRHSucesso: ['consultaQuadroInativosADMRH'],
    limpar: [],
    setConsultaQuadroInativosADMRHEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaQuadroInativosADMRH = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaQuadroInativosADMRHInicio())
        let serv = new ConsultaQuadroInativosADMRHService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaQuadroInativosADMRHSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaQuadroInativosADMRHErro(error)))
    }
}

const buscaConsultaQuadroInativosADMRHInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaQuadroInativosADMRHErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaQuadroInativosADMRHSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaQuadroInativosADMRH.resultado,
        dataSincronizacaoDados: action.consultaQuadroInativosADMRH.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaQuadroInativosADMRH.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaQuadroInativosADMRHEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_QUADRO_INATIVOS_ADMRH_INICIO]: buscaConsultaQuadroInativosADMRHInicio,
    [Types.BUSCA_CONSULTA_QUADRO_INATIVOS_ADMRH_ERRO]: buscaConsultaQuadroInativosADMRHErro,
    [Types.BUSCA_CONSULTA_QUADRO_INATIVOS_ADMRH_SUCESSO]: buscaConsultaQuadroInativosADMRHSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_QUADRO_INATIVOS_ADMRH_ESTADO_DT]: setConsultaQuadroInativosADMRHEstadoDT,
})
